module.exports = __webpack_public_path__ + "img/9788952747402.8c049253.jpg";